import ApiBase from '@/sag-core/base/ApiBase'
import https from '@/apis/https.js'
import tools from '@/sag-core/tools'
import store from '@/store'
//取得所有產線

let api = null
api = tools.mergeDeep(new ApiBase(), {
    
    apiGetAllDepartment() {
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/APSKANUI01/GetAllDepartment',
            method: 'post'
        })
    },

    //取得產線所有人員
    apiGetProdLineEmployee(data){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/APSKANUI01/GetProdLineEmployee',
            method: 'post',
            data
        })
    },

    apiGetVueUserCalendar(data){
      return https({
          url: 'https://eip2.sag.tw/SAGVueFrameApi/APSKANUI01/GetVueUserCalendar',
          method: 'post',
          data
      })
    },

    apiGetEmplyeeInfo(data){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/APSKANUI01/GetEmplyeeInfo',
            method: 'post',
            data: data
        })
    }
})

if(store.state.webConfig.apiTest){
    api = tools.mergeDeep(new ApiBase(), {
        
        apiGetAllDepartment() {
            return https({
                url: 'http://localhost:12345/APSKANUI01/GetAllDepartment',
                method: 'post'
            })
        },
    
        //取得產線所有人員
        apiGetProdLineEmployee(data){
            return https({
                url: 'http://localhost:12345/APSKANUI01/GetProdLineEmployee',
                method: 'post',
                data
            })
        },
    
        apiGetVueUserCalendar(data){
          return https({
              url: 'http://localhost:12345/APSKANUI01/GetVueUserCalendar',
              method: 'post',
              data
          })
        },
    
        /* 範例
        data = { 
            "staffNo": "096134",
            "date": "2022-12-01"
        }
        */
        apiGetEmplyeeInfo(data){
            return https({
                url: 'http://localhost:12345/APSKANUI01/GetEmplyeeInfo',
                method: 'post',
                data: data
            })
        }
    })
}

export default api